import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Actu } from '../_models/actu';

@Injectable({ providedIn: 'root' })
export class ActuService {
    constructor(
        private router: Router,
        private http: HttpClient
    ) {}

    list(type = 'list', search = ''): any {
    	let filters = {
    	  type: type == "list" ? "list" : "slider",
    	  search: search
    	};
    	return this.http.get<Actu[]>(`${environment.apibase}actus`, { params: filters });
    }
    
    single(id: any): any {
    	return this.http.get<Actu[]>(`${environment.apibase}actu/${id}`);
    }
}